import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    myReports_title: "Мои табели",
    myReports_myChildren: 'Мои дети',
    myReports_childSurname: 'Фамилия',
    myReports_childName: 'Имя',
    myReports_childBirthdayDate: 'Дата рождения',
    myReports_ddo: 'Дошкольная организация',
    myReports_infoDDO: 'Информация о дошкольной организации',
    myReports_legalLocality: 'Юридический адрес',
    myReports_startDateAttempt: 'Начало посещений',
    myReports_endDateAttempt: 'Окончание посещений',
    myReports_fromDate: 'с {{date}}',
    myReports_noData: 'Нет данных',
    myReports_availableConfirmDate: 'Подписание или отказ доступны только с 1 по 10 число текущего месяца за прошлый месяц.',
    myReports_sign: 'Подписать',
    myReports_reject: 'Отказать',
    myReports_signed: 'Подписан',
    myReports_rejected: 'Отказан',
    myReports_ReasonOfReject:'Причина отказа',
    myReports_rejectReasonPlaceholder:'Напишите причину отказа',
    myReports_confirm:'Подтвердить',
    myReports_cancel:'Отмена',
    myReports_weekday_mon: 'Пн',
    myReports_weekday_tue: 'Вт',
    myReports_weekday_wed: 'Ср',
    myReports_weekday_thu: 'Чт',
    myReports_weekday_fri: 'Пт',
    myReports_weekday_sat: 'Сб',
    myReports_weekday_sun: 'Вс',
    myReports_attempted:'Посещено',
    myReports_absenceWithReason:'Отсутствие с причиной',
    myReports_absenceWithoutReason:'Отсутствие без причины',
    myReports_reason_leaveApplication: "Заявление в отпуск",
    myReports_reason_technicalError: "Техническая причина",
    myReports_reason_parentStatement: "Заявление от родителей",
    myReports_reason_familySituation: "Семейная ситуация",
    myReports_reason_reference: "Справка",
    myReportsHistory_title:'История моих табелей',
    myReportsHistory_childFullnameColumn:"ФИО ребенка",
    myReportsHistory_childIinColumn:'ИИН ребенка',
    myReportsHistory_childReportMonthColumn:'Месяц подтвеждения/отказа',
    myReports_status:"Статус",
    myReports_date:'Дата подтверждения/отказа',
    myReportsHistory_viewReport:'Просмотреть табель',
    myReports_errorLoad:"Не удалось загрузить табель",
    myReports_errorConfirmOrReject:'Не удалось выполнить действие',
    myReportsCommon_loading:'Загрузка данных',
  },
  kk: {
    myReports_title: "Менің табельдерім",
    myReports_myChildren: "Менің балаларым",
    myReports_childSurname: "Тегі",
    myReports_childName: "Аты",
    myReports_childBirthdayDate: "Туған күні",
    myReports_ddo: "Мектепке дейінгі ұйым",
    myReports_infoDDO: "Мектепке дейінгі ұйым туралы ақпарат",
    myReports_legalLocality: "Заңды мекенжайы",
    myReports_startDateAttempt: "Бару басталған күні",
    myReports_endDateAttempt: "Бару аяқталған күні",
    myReports_fromDate: "{{date}} бастап",
    myReports_noData: "Деректер жоқ",
    myReports_availableConfirmDate: "Қол қою немесе бас тарту өткен ай үшін ағымдағы айдың 1-інен 10-ына дейін ғана қолжетімді.",
    myReports_sign: "Қол қою",
    myReports_reject: "Бас тарту",
    myReports_signed: "Қол қойылған",
    myReports_rejected: "Бас тартылған",
    myReports_ReasonOfReject: "Бас тарту себебі",
    myReports_rejectReasonPlaceholder: "Бас тарту себебін жазыңыз",
    myReports_confirm: "Растау",
    myReports_cancel: "Болдырмау",
    myReports_weekday_mon: "Дс",
    myReports_weekday_tue: "Сс",
    myReports_weekday_wed: "Ср",
    myReports_weekday_thu: "Бс",
    myReports_weekday_fri: "Жм",
    myReports_weekday_sat: "Сб",
    myReports_weekday_sun: "Жс",
    myReports_attempted: "Қатысты",
    myReports_absenceWithReason: "Себеппен келмеді",
    myReports_absenceWithoutReason: "Себепсіз келмеді",
    myReports_reason_leaveApplication: "Демалыс туралы өтініш",
    myReports_reason_technicalError: "Техникалық себеп",
    myReports_reason_parentStatement: "Ата-аналардың өтініші",
    myReports_reason_familySituation: "Отбасылық жағдай",
    myReports_reason_reference: "Анықтама",
    myReportsHistory_title: "Менің табельдерімнің тарихы",
    myReportsHistory_childFullnameColumn: "Баланың аты-жөні",
    myReportsHistory_childIinColumn: "Баланың ЖСН",
    myReportsHistory_childReportMonthColumn: "Растау/бас тарту айы",
    myReports_status: "Мәртебе",
    myReports_date: "Растау/бас тарту уақыты",
    myReportsHistory_viewReport: "Табельді көру",
    myReports_errorLoad: "Табельді жүктеу мүмкін болмады",
    myReports_errorConfirmOrReject: "Әрекетті орындау мүмкін болмады",
    myReportsCommon_loading:'Деректерді жүктеу',

  }
});
